<template>
    <div class="special-event-market__item-wrapper--terminal">
        <div class="special-event-market__item--terminal">
            <div class="special-event-market__item-info--terminal">
                <span class="special-event-market__item-info-title--terminal">
                    {{ specialMarketEvent.name }}
                </span>
            </div>
            <span
                v-show="!!specialMarketEvent.specialBetValue"
                class="special-bet-value--terminal"
            >
                {{ specialMarketEvent.specialBetValue }} +/-
            </span>
        </div>
        <div class="special-event-market__item-odds--terminal">
            <Pick
                :class="pickClass(odd)"
                v-for="(odd, index) in odds"
                :key="index"
                v-bind="odd"
                :isRefund="isRefund(odd)"
                :symbol="odd.name"
                @click="$emit('oddClick', { odd, index })"
            />
        </div>
    </div>
</template>

<script>
    import Pick from 'src/terminal/app/modules/shared/event/SportOfferPick';
    import { EventStatus } from '@core/models/tickets/enums';

    export default {
        name: 'SpecialGridRow',
        props: {
            specialMarketEvent: {
                type: Object,
                required: true
            },
            selections: {
                type: Array,
                required: false,
                default: () => []
            },
            isResults: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            odds() {
                return this.isResults ? this.specialMarketEvent.odds : this.unresolvedOdds;
            },
            unresolvedOdds() {
                return this.specialMarketEvent.odds.filter((odd) => odd.isShownOnOffer);
            },
        },
        methods: {
            isSelected(odd) {
                if (!odd.value) {
                    return false;
                }
                return this.selections.find((selection) => selection.getOddId() === odd.id);
            },
            pickClass(odd) {
                let cssClass = '';

                if (odd.value) {
                    cssClass += 'odd';
                }

                if (this.isSelected(odd)) {
                    cssClass += ' is-selected';
                }

                if (odd.status) {
                    cssClass += ` ${odd.status}`;
                }
                return cssClass;
            },
            isRefund(odd) {
                return odd.status === EventStatus.refund;
            }
        },
        components: {
            Pick
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/special/SpecialGridRow.vue